import { useContext } from 'react';
import { LocaleContext } from '../Contexts/localeContext';

export default function useLocaleContext(){
    return useContext(LocaleContext);
}